<template>
  <div class="tlj">
    <el-row>
      <el-col :span="24">
        <el-alert
            title="温馨提示"
            type="success"
            close-text="知道了"
            show-icon>
          <p>请填写滴滴结算支付宝，每个月系统会根据填写的支付宝打款 <a style="color: #ff0036"
                                            href="https://www.yuque.com/yifakeji/irpssl/vcfoxs"
                                            target="_blank">点击查看教程</a>
          </p>
        </el-alert>

      </el-col>
    </el-row>
    <el-row class="">
      <el-col :span="24">
        <el-form ref="item" :rules="rules" :model="item" label-width="210px" label-position="left">
          <el-form-item label="结算支付宝账号" prop="alipay">
            <el-col :span="12">
              <el-input v-model="item.alipay" placeholder="请输入结算支付宝账号"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="结算支付宝姓名" prop="alipayName">
            <el-col :span="12">
              <el-input v-model="item.alipayName" placeholder="请输入结算支付宝姓名"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="medium" @click="onSubmit('item')">保存</el-button>
            <el-button size="medium" @click="activeNames=[]">取消</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import {accountConfigApi} from "../../common/accountConfigApi"

export default {
  data() {
    return {
      page: 1,
      pageSize: 10,
      items: [],
      totalCount: 0,
      activeNames: [],
      item: {
        alipay: ''
      },
      maxPids: 50,
      rules: {
        alipay: [
          {required: true, message: '请输入支付宝账号', trigger: 'blur'},
        ],
        alipayName: [
          {required: true, message: '请输入支付宝姓名', trigger: 'blur'},
        ]
      }

    }

  },
  watch: {
    /*'item.pids': {
        handler: function () {
            for (var i = 0; i < this.item.pids.length; i++) {
                if (this.item.pids[i].pid && this.item.pids[i].pid.trim() != '') {
                    this.item.pid = 'valid-pid'
                    break
                }
            }
        }
    },*/
  },
  computed: {},
  mounted() {
    console.log("mounted")
  },
  created() {
    var that = this;
    accountConfigApi.getAccountConfigs.call(that, {}, function (res) {
      if (res.result.items.length > 0) {
        that.item = res.result.items[0]
      }
    })
  },
  methods: {
    formatter(row, index) {
      if (row.upcUse == true) {
        return "是"
      }
      if (row.upcUse == false) {
        return "否"
      }
      return "";
    },
    formatterNotRebate(row, index) {
      if (row.notRebate == true) {
        return "是"
      }
      if (row.notRebate == false) {
        return "否"
      }
      return "";
    },
    initRule() {
      this.item.pids.push({name: "", pid: ""})
    },
    addPid(index, item) {
      if (item.pids.length >= this.maxPids) {
        this.failMsg("最大支持" + this.maxPids + "个pid");
        return;
      }
      item.pids.splice(index + 1, 0, {name: '', pid: ''});
    },
    deletePid(index, item) {
      item.pids.splice(index, 1)
    },
    handleCurrentChange() {
      var that = this
      taokeAppKeyApi.getTaokeAppKey.call(that, {
        page: this.page,
        pageSize: this.pageSize
      }, function (res) {
        if (res.result.data) {
          that.items = res.result.data
        }
        if (res.result.totalCount) {
          that.totalCount = res.result.totalCount
        }
      })
    },
    endTimeMode(mode) {
      if (mode == 1) {
        return "相对时间"
      } else {
        return "绝对时间"
      }
    },
    newAppkey() {
      this.activeNames = ['1']
      this.item = {
        pids: [{name: '', pid: ''}]
      }
    },
    editAppkey(item) {
      this.activeNames = ['1']
      this.item = item;
      this.item.isEditing = true
    },
    onSubmit(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          accountConfigApi.createOrUpdateConfig.call(that, that.item, function (res) {
            if (res.result.item) {
              that.item.id = res.result.item.id
            }
          })
        }
      });
    }
  }

}

</script>
<style lang="scss">
.tlj {
  .el-table__row {
    td {
      max-height: 150px;
    }

    .table-cell-item {
      width: 100%;
    }
  }


  .el-table .cell {
    max-height: 100px;
  }

  .col-item-3 {
    width: 30%;
  }

  .col-item-7 {
    width: 70%;
  }

  .el-item-12 {
    margin-left: 10px;
  }
}

</style>